import { API, authClient } from "../index";

export const postProductFamily = async (family, accessToken) => {
	return authClient(accessToken).post(`${API}/product-families`, family);
};

export const getProductFamilies = (accessToken) => {
	return authClient(accessToken).get(`${API}/product-families`);
};

export const getProductFamilyById = (id, accessToken) => {
	return authClient(accessToken).get(`${API}/product-families/${id}`);
};

export const updateProductFamily = async (id, family, accessToken) => {
	return authClient(accessToken).put(`${API}/product-families/${id}`, family);
};

export const deleteProductFamily = (id, accessToken) => {
	return authClient(accessToken).delete(`${API}/product-families/${id}`);
};
